// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const SocialLinkedin = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 42 42" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g transform="translate(1 1)" fill="none" fillRule="evenodd">
			<circle stroke="#0079BA" cx={20} cy={20} r={20} />
			<path
				d="M27 26.976h-2.9v-4.54c0-1.083-.02-2.475-1.507-2.475-1.51 0-1.741 1.18-1.741 2.397v4.618h-2.9v-9.335h2.784v1.275h.038c.388-.734 1.334-1.508 2.746-1.508 2.938 0 3.48 1.934 3.48 4.447v5.121zM14.683 16.364a1.683 1.683 0 1 1 0-3.365 1.683 1.683 0 0 1 0 3.365zM13.23 26.976h2.902v-9.335H13.23v9.335z"
				fill="#0079BA"
			/>
		</g>
	</svg>
);
export default SocialLinkedin;
